import React, { useState, useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { PatientDto } from "../../types/patient";
import { GdprModal } from "../../Modals/GdprSendModal";
import { DataTable } from "../../Components/DataTable";

interface PatientTableProps {
  patients: PatientDto[];
  loading?: boolean;
}

const PatientTable: React.FC<PatientTableProps> = ({ 
  patients,
  loading = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPatientId, setSelectedPatientId] = useState<number | null>(
    null,
  );

  const openGdprModal = (patientId: number) => {
    setSelectedPatientId(patientId);
    setIsModalOpen(true);
  };

  const columns = useMemo<ColumnDef<PatientDto>[]>(
    () => [
      {
        accessorKey: "lastName",
        header: "Επώνυμο",
      },
      {
        accessorKey: "firstName",
        header: "Όνομα",
      },
      {
        accessorKey: "age",
        header: "Ηλικία",
      },
      {
        accessorKey: "status",
        header: "Κατάσταση",
      },
      {
        id: "gdpr",
        header: "GDPR",
        enableColumnFilter: false,
        cell: ({ row }) => {
          const p = row.original;
          return p.isGdprSent ? (
            <span className="text-xs text-primary font-medium">Εστάλη</span>
          ) : (
            <button
              onClick={(e) => {
                e.stopPropagation(); // Σταματάει το κλικ εδώ για να μην ανοίξει ο ασθενής
                openGdprModal(Number(p.patientId));
              }}
              className="text-xs bg-primary text-white px-3 py-1 rounded hover:bg-darkprimary transition"
            >
              Αποστολή GDPR
            </button>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <DataTable
        columns={columns}
        data={patients || []}
        loading={loading}
        onRowClick={(patient) => {
          window.open(`/patients/${patient.patientId}`, "_blank");
        }}
      />

      {selectedPatientId && (
        <GdprModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          patientId={selectedPatientId}
        />
      )}
    </>
  );
};

export default PatientTable;
